module.exports = __webpack_public_path__ + "media/images/icons/vendors/eventhost-e1b637e9b1ec395d7262472862ef9f0c.png";